import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { Button, UploadFile } from "antd";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import { updateBatchPaymentAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { sliceString } from "../../../utils/string";
import { extension } from "../../../utils/array";
import { toast } from "../../../helpers/toast";
import { UploadChangeParam } from "antd/es/upload";
import CustomModal from "../../common/CustomModal";
import Dragger from "antd/es/upload/Dragger";
import ExclamationIcon from "../../../assets/icons/ExclamationIcon";
import CorrenctIcon from "../../../assets/icons/CorrenctIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import FileIcon from "../../../assets/icons/FileIcon";
import useModal from "../../../hooks/useModal";
import InvoiceConfirmModal from "./InvoiceConfirmModal";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  closable?: boolean;
  getData: () => void;
};

export default function ImportPaymentInvoiceModal({
  open,
  handleClose,
  data,
  closable = false,
  getData,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");
  // const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileList, setFileList] = useState<{ name: string; url: string }[]>([]);
  const [pdfUrl, setPdfUrl] = useState("");
  const dispatch = useAppDispatch();
  const { postLoading } = useAppSelector((state) => state.supplier);

  const {
    open: invoiceConfirmOpen,
    toggle: invoiceConfirmToggle,
    handleOpen: handleInvoiceConfirmOpen,
  } = useModal();

  // const handleUpload = async (file: any) => {
  //   const formData = new FormData();
  //   formData.append("photo", file);
  //   formData.append("name", file.name);

  //   setLoading(true);

  //   try {
  //     const response = await AXIOS.post(`${BASE_API.fileUpload}`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     const fileUrl = response?.data?.photo;

  //     const newValue = {
  //       vat: fileUrl,
  //     };

  //     dispatch(
  //       updateBatchPaymentAsync({
  //         data: newValue,
  //         others: {
  //           reRender,
  //           id: data?._id,
  //         },
  //       })
  //     );

  //     if (response.status === 200) {
  //       setFileName(`${sliceString(fileUrl, 30, "...")}.${extension(fileUrl)}`);

  //       setPdfUrl(fileUrl);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     toast("error", "File upload fail");
  //     setLoading(false);
  //   }

  //   return false;
  // };

  const handleUpload = async (file: any) => {
    const formData = new FormData();
    formData.append("photo", file);
    formData.append("name", file.name);

    setLoading(true);

    try {
      const response = await AXIOS.post(`${BASE_API.fileUpload}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const fileUrl = response?.data?.photo;

      if (response.status === 200) {
        setFileList((prev) => [
          ...prev,
          {
            name: `${sliceString(file.name, 30, "...")}`,
            url: fileUrl,
          },
        ]);
      }
    } catch (error) {
      toast("error", "File upload failed");
    } finally {
      setLoading(false);
    }

    return false;
  };

  // const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
  //   setFileList(info.fileList);

  //   if (info.file.status === "removed") {
  //     setPdfUrl("");
  //     setFileName("");
  //   }
  // };

  const handleDelete = (index: number) => {
    setFileList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleConfirmUpload = () => {
    const newData = {
      financeOne: fileList.map((file) => file.url),
    };

    dispatch(
      updateBatchPaymentAsync({
        data: newData,
        others: { reRender, id: data?._id },
      })
    );
  };

  function reRender(val: boolean) {
    if (val) {
      handleClose();
      invoiceConfirmToggle();
      setFileList([]);
      getData();
    }
  }

  return (
    <>
      {invoiceConfirmOpen?.type === "INVOICE_CONFIRM" && (
        <InvoiceConfirmModal
          open={invoiceConfirmOpen?.open}
          data={invoiceConfirmOpen?.data}
          handleClose={invoiceConfirmToggle}
          reRender={reRender}
          handleConfirmUpload={handleConfirmUpload}
          postLoading={postLoading}
        />
      )}

      <CustomModal
        width={500}
        title=""
        open={open}
        handleClose={handleClose}
        closable={closable}
      >
        <div className="p-6">
          <h4 className="text-body text-lg font-medium leading-normal relative -top-[2.5px] mb-4">
            Are you sure you want to update the payment status of Invoice
            #INV-1023?
          </h4>
          <div className="flex gap-4 items-center justify-start mb-4">
            <CorrenctIcon />
            <div>
              <p className="text-body text-sm font-normal leading-normal mt-1">
                Yes, This is Paid
              </p>
            </div>
          </div>

          <Dragger
            name="file"
            action=""
            accept=".pdf"
            maxCount={1}
            showUploadList={false}
            beforeUpload={handleUpload}
            disabled={loading}
            className="import_excel"
          >
            <Button
              className="flex justify-between items-center"
              size="large"
              disabled={loading}
              style={{ width: "100%" }}
            >
              <div className="flex items-center gap-2 text-sm font-normal font-roboto text-[#8797ae]">
                <span className="text-accent font-medium text-base leading-7 relative">
                  Choose File
                </span>
                <span className="border-r border-solid border-l-0 border-y-0 border-others-border h-4" />
                {loading ? "Uploading..." : "No file chosen"}
              </div>
            </Button>
          </Dragger>

          <div className="mt-4 space-y-2">
            {fileList.map((file, index) => (
              <div
                key={index}
                className="flex justify-between items-center px-2 py-1 bg-slate-100 rounded-md"
              >
                <div className="flex items-center justify-start gap-3">
                  <FileIcon />
                  <div className="text-zinc-700 text-sm font-normal">
                    {file.name}
                  </div>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => handleDelete(index)}
                >
                  <DeleteIcon />
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-7 gap-3">
            <Button
              onClick={() => handleClose()}
              size="large"
              className="w-52 cancel_btn !bg-[#8897AE] !text-white !border-[2px] !border-transparent hover:!border-[#8897AE] transition-all duration-200"
            >
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              className="w-52"
              onClick={() =>
                handleInvoiceConfirmOpen({
                  type: "INVOICE_CONFIRM",
                  //   data: record,
                })
              }
            >
              Upload
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
